export { default } from "./Table"
